export { default } from "./Table"
